module.exports = __webpack_public_path__ + "img/ad_coupon_3@2x.3036f666.png";